import { render, staticRenderFns } from "./StudioInfo.vue?vue&type=template&id=713c1810&scoped=true"
import script from "./StudioInfo.vue?vue&type=script&lang=js"
export * from "./StudioInfo.vue?vue&type=script&lang=js"
import style0 from "./StudioInfo.vue?vue&type=style&index=0&id=713c1810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713c1810",
  null
  
)

export default component.exports